import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls the window to the top
 * whenever the route changes. This is especially important for mobile users
 * to ensure they always start at the top of a new page.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when the route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' instead of 'smooth' to avoid animation issues
    });
  }, [pathname]);

  return null; // This component doesn't render anything
}

export default ScrollToTop;
